import { render, staticRenderFns } from "./addPrf.vue?vue&type=template&id=3644f1ac&scoped=true&"
import script from "./addPrf.vue?vue&type=script&lang=js&"
export * from "./addPrf.vue?vue&type=script&lang=js&"
import style0 from "./addPrf.vue?vue&type=style&index=0&id=3644f1ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3644f1ac",
  null
  
)

export default component.exports